import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Building2, ChevronRight } from "lucide-react";

export default function Step1Aantal({ aantal, onAantalChange, onNext }) {
  return (
    <Card className="p-6" data-testid="wizard-step-1">
      <h2 className="text-xl font-medium mb-2 flex items-center gap-2">
        <Building2 className="h-5 w-5" /> Hoeveel locaties heeft uw organisatie?
      </h2>
      <p className="text-sm text-neutral-600 mb-4">
        Voer het totaal aantal opvanglocaties in. U kunt dit later nog aanpassen.
      </p>
      <div className="max-w-xs">
        <Label>Aantal locaties</Label>
        <Input
          type="number" min={1} max={30}
          value={aantal}
          onChange={e => onAantalChange(e.target.value)}
          data-testid="wizard-aantal-locaties"
          className="text-lg"
        />
      </div>
      <div className="mt-6 flex justify-end">
        <Button onClick={onNext} data-testid="wizard-next-1"
                style={{ background: "var(--sage)" }} className="text-white">
          Volgende <ChevronRight className="h-4 w-4 ml-1" />
        </Button>
      </div>
    </Card>
  );
}
